function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useErrorContext } from '@magento/peregrine/lib/context/unhandledErrors';
import App from './app';
import { useErrorBoundary } from './useErrorBoundary';
var AppContainer = () => {
  var ErrorBoundary = useErrorBoundary(App);
  var [unhandledErrors, errorApi] = useErrorContext();
  return /*#__PURE__*/React.createElement(ErrorBoundary, _extends({
    unhandledErrors: unhandledErrors
  }, errorApi));
};
export default AppContainer;